<template>
  <div>
    <label class="form-label">{{ $t('Prêmios') }}</label>
    <multiselect
      v-model="selectedOption"
      :options="optionsPremios"
      :multiple="false"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      :allowEmpty="false"
      :preselectFirst="true"
      placeholder=""
      label="name"
      track-by="id"
      id="filtroPago"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import user from '@/store/modules/user';

export default {
  components: {
    Multiselect
  },
  props: ['value'],
  data() {
    return {
      selectedOption: this.value ? this.optionsPremios.find((option) => option.id == this.value) : null
    };
  },
  watch: {
    selectedOption(newVal) {
      this.$emit('input', newVal.id);
    },
    value(newVal) {
      this.selectedOption = this.optionsPremios.find((option) => option.id == newVal) || null;
    }
  },
  computed: {
    premioPago() {
      const configuracao = user.state.info.configuracao ? JSON.parse(user.state.info.configuracao) : null;
      return configuracao && configuracao?.premioPago ? parseInt(configuracao?.premioPago) : null;
    },
    optionsPremios() {
      let options = [];
      if ([0, NaN, 2, null].includes(this.premioPago)) {
        options.push({ id: null, name: this.$t('Todos os Prêmios') });
      }
      if ([0, 1, null].includes(this.premioPago)) {
        options.push({ id: true, name: this.$t('Pagos') });
      }
      if ([0, 2, null].includes(this.premioPago)) {
        options.push({ id: false, name: this.$t('Não Pagos') });
      }
      return options;
    }
  }
};
</script>

<style lang="scss" scoped></style>
